<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="userAccountsTable.additionalFilters"
                                    :default-sort="userAccountsTable.defaultSort"
                                    :excel="true"
                                    :fields="userAccountsTable.headers"
                                    :header-selection-key="'user-accounts-headers'"
                                    :filter-save-key="'user-accounts-filters'"
                                    :height="userAccountsTable.height"
                                    :total-records="userAccountsTable.total"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in userAccountsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(props.item.id, true)"
                                    >
                                        <td
                                            v-if="userAccountsTable.selectedHeaders.includes('first_name')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.first_name }}
                                        </td>
                                        <td
                                            v-if="userAccountsTable.selectedHeaders.includes('last_name')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.last_name }}
                                        </td>
                                        <td
                                            v-if="userAccountsTable.selectedHeaders.includes('email')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.email }}
                                        </td>
                                        <td
                                            v-if="userAccountsTable.selectedHeaders.includes('user_role_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.user_role_display }}
                                        </td>
                                        <td
                                            v-if="userAccountsTable.selectedHeaders.includes('contact_number')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.contact_number }}
                                        </td>
                                        <td
                                            v-if="userAccountsTable.selectedHeaders.includes('active')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.active" small>fa-check</v-icon>
                                        </td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'UserAccounts',
    components: {TheTable},
    data: function () {
        return {
            userAccountsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.firstName'), value: 'first_name', type: 'string', allowFilter: true},
                    {text: this.$t('fields.lastName'), value: 'last_name', type: 'string', allowFilter: true},
                    {text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.role'),
                        value: 'user_role_id',
                        type: 'dropdown|user-roles',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.contactNumber'), value: 'contact_number', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'first_name',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/user-accounts/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/user-accounts/' + id);
            } else {
                let routeData = this.$router.resolve('/user-accounts/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.userAccountsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'users', request, (data, success) => {
                if (success) {
                    vm.userAccountsTable.items = data.items;
                    vm.userAccountsTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'users',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/users', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.userAccountsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        if (this.$myStore.state.user.user_role_id != 1) {
            this.$router.replace('/dashboard');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.userAccounts'), href: '/#/user-accounts', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
